import angular from "angular";

angular
    .module('app')
    .component('userAnswerModal', {
        template: require('./user-answer-modal.html'),
        controller: ['$sce', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($sce) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.answer = $ctrl.resolve.answer;
    };
}
